import { withErrorBoundary } from "@sentry/nextjs";
import { marked } from "marked";
import { FC } from "react";
import styled from "styled-components";

interface Props {
  children: string;
  className?: string;
  style?: { [key: string]: string };
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
}

// eslint-disable-next-line react/require-default-props
export const Markdown: FC<Props> = withErrorBoundary(({ children, as, ...props }) => {
  if (!children) return null;

  return <StyledMarkdown dangerouslySetInnerHTML={{ __html: marked.parse(children) }} as={as ?? "div"} {...props} />;
}, {});

const StyledMarkdown = styled.div`
  ul > li,
  ol > li {
    list-style-position: outside;
  }

  ul {
    padding-left: 28px;
  }

  /* stylelint-disable-next-line no-descending-specificity */
  ol > li {
    list-style-type: decimal;
  }

  /* stylelint-disable-next-line no-descending-specificity */
  ul > li {
    list-style-type: disc;
  }

  a {
    text-decoration: underline;
    border-radius: 4px;
  }

  a:hover {
    text-decoration: none;
  }

  a:active {
    opacity: 0.7;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    li:not(:first-child) {
      padding-top: 26px;
    }
  }
`;
